export const version = '2.49.2';
//# sourceMappingURL=version.js.map